import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=b1b74160&scoped=true&lang=pug&"
import script from "./MenuLeft.vue?vue&type=script&lang=js&"
export * from "./MenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=b1b74160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b74160",
  null
  
)

export default component.exports